import React, { useMemo, useState } from "react";
import { Divider, SelectTabData, SelectTabEvent, Tab, TabList } from "@fluentui/react-components";

import { YellowpadPlaybooks } from "./yellowpad-playbooks";
import { MyPlaybooks } from "./my-playbooks";
import { Settings } from "./settings";
// import { Marketplace } from "./marketplace";
import { useConfigurationsStyles } from "./styles";

import { useDocumentClassification } from "@/context/document-classification";
import { NODE_ENV } from "@/constants";

type ConfigurationsTab = "yellowpad-playbooks" | "my-playbooks" | "settings" | "marketplace";

export function Configurations() {
  const styles = useConfigurationsStyles();
  const { playbooks } = useDocumentClassification();

  const [activeTab, setActiveTab] = useState<ConfigurationsTab>("my-playbooks");

  const myPlaybooks = useMemo(() => playbooks.filter((playbook) => playbook.customerId), [playbooks]);
  const yellowpadPlaybooks = useMemo(() => playbooks.filter((playbook) => !playbook.customerId), [playbooks]);

  const handleSelectTab = (_: SelectTabEvent, data: SelectTabData) => {
    setActiveTab(data.value as ConfigurationsTab);
  };

  return (
    <div>
      <Divider />
      <TabList selectedValue={activeTab} onTabSelect={handleSelectTab}>
        <Tab id="yellowpad-playbooks" value="yellowpad-playbooks" className={styles.tab}>
          Yellowpad Playbooks
        </Tab>
        <Tab id="my-playbooks" value="my-playbooks" className={styles.tab}>
          My Playbooks
        </Tab>
        {NODE_ENV !== "production" && (
          <Tab id="settings" value="settings" className={styles.tab}>
            Settings
          </Tab>
        )}
        {/* <Tab value="marketplace">Marketplace</Tab> */}
      </TabList>
      {activeTab === "yellowpad-playbooks" && <YellowpadPlaybooks playbooks={yellowpadPlaybooks} />}
      {activeTab === "my-playbooks" && <MyPlaybooks playbooks={myPlaybooks} />}
      {activeTab === "settings" && NODE_ENV !== "production" && <Settings />}
      {/* {activeTab === "marketplace" && <Marketplace />} */}
    </div>
  );
}
